// extracted by mini-css-extract-plugin
export var banner = "_rq-0";
export var settingRow = "_rq-2";
export var titleIcon = "_rq-1";